import React from 'react';
import { Component } from 'react';
import { recuperarConfEmpresa } from '../util/applicationContext';
import locaisEmbarqueDetalhadoTurissulpassagens from './layout/LocaisEmbarquePorCidade/locaisEmbarqueDetalhadoTurissulpassagens';

const ITENS_POR_PAGINA = 50;
const MAX_NUMEROS_PAGINA = 10;

export default class LocaisEmbarquePorCidade extends Component {

    constructor(props) {
        super(props);
        this.state = {
            termoBusca: '',
            paginaAtual: 1
        };
    }

    obterLocaisEmbarque() {
        const confEmpresa = recuperarConfEmpresa();
        const ehTurissulpassagens = confEmpresa.pastaEstilo === 'turissulpassagens';

        if (ehTurissulpassagens) {
            return locaisEmbarqueDetalhadoTurissulpassagens;
        }

        return [];
    }

    normalizar(texto) {
        return texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    }

    montarLinkGoogleMaps(local) {
        if (local.linkGoogleMaps) {
            return local.linkGoogleMaps;
        }

        const busca = `${local.localEmbarque}, ${local.cidade} - ${local.uf}`;
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(busca)}`;
    }

    handleBuscaChange = (event) => {
        this.setState({
            termoBusca: event.target.value,
            paginaAtual: 1
        });
    }

    irParaPagina = (numero) => {
        this.setState({ paginaAtual: numero });
    }

    paginaAnterior = () => {
        this.setState((prevState) => ({
            paginaAtual: Math.max(prevState.paginaAtual - 1, 1)
        }));
    }

    proximaPagina = (totalPaginas) => {
        this.setState((prevState) => ({
            paginaAtual: Math.min(prevState.paginaAtual + 1, totalPaginas)
        }));
    }

    primeiraPagina = () => {
        this.setState({ paginaAtual: 1 });
    }

    ultimaPagina = (totalPaginas) => {
        this.setState({ paginaAtual: totalPaginas });
    }

    render() {
        let confEmpresa = recuperarConfEmpresa();
        let nomeEmpresa = confEmpresa.nome.toUpperCase();
        const { termoBusca, paginaAtual } = this.state;

        const locaisEmbarque = this.obterLocaisEmbarque();
        const termoNormalizado = this.normalizar(termoBusca);
        const locaisFiltrados = locaisEmbarque.filter(local =>
            this.normalizar(local.cidade).includes(termoNormalizado)
        );

        const totalPaginas = Math.max(1, Math.ceil(locaisFiltrados.length / ITENS_POR_PAGINA));
        const paginaAtualCorrigida = Math.min(paginaAtual, totalPaginas);
        const indiceFinal = paginaAtualCorrigida * ITENS_POR_PAGINA;
        const indiceInicial = indiceFinal - ITENS_POR_PAGINA;
        const locaisDaPagina = locaisFiltrados.slice(indiceInicial, indiceFinal);

        let inicioIntervalo = Math.max(1, paginaAtualCorrigida - Math.floor(MAX_NUMEROS_PAGINA / 2));
        let fimIntervalo = Math.min(totalPaginas, inicioIntervalo + MAX_NUMEROS_PAGINA - 1);
        if (fimIntervalo - inicioIntervalo < MAX_NUMEROS_PAGINA - 1) {
            inicioIntervalo = Math.max(1, fimIntervalo - MAX_NUMEROS_PAGINA + 1);
        }

        const numerosPagina = [];
        for (let i = inicioIntervalo; i <= fimIntervalo; i++) {
            numerosPagina.push(i);
        }

        return (
            <div className='conteudo'>
                <div className='col-12 conteudo-internas'>
                    <div className='card border-0'>
                        <div className='card-body'>
                            <div className='loginHeader'>
                                <h1 id='secao-locais-embarque'>Confira os locais de embarques e suas localizações!</h1>
                                <div className="divider"/>
                            </div>
                            <div className='card'>
                                <div className='card-body informacoes'>
                                    <strong><h1>Confira os locais de embarques e suas localizações! – {nomeEmpresa}</h1></strong><br/>
                                    <p>Atualizada em 17 de Setembro de 2026 </p>

                                    <div className="filtro-container busca-locais-embarque">
                                        <div className="filtro-item">
                                            <label htmlFor="termoBusca">Buscar por cidade</label>
                                            <input
                                                type="text"
                                                id="termoBusca"
                                                name="termoBusca"
                                                value={termoBusca}
                                                onChange={this.handleBuscaChange}
                                                placeholder="Digite o nome da cidade"
                                                className="filtro-input"
                                            />
                                        </div>
                                    </div>

                                    <div className='lista-locais-embarque'>
                                        {locaisDaPagina.map((local, index) => (
                                            <div className='card-local-embarque' key={index}>
                                                <div className='info-cidade-embarque'>
                                                    <h3>{local.cidade}</h3>
                                                    <p><strong>Local de embarque:</strong> {local.localEmbarque}</p>
                                                </div>
                                                <a
                                                    className='link-google-maps'
                                                    href={this.montarLinkGoogleMaps(local)}
                                                    target='_blank'
                                                    rel='noreferrer'
                                                >
                                                    <span className='fa fa-map-marker' aria-hidden='true'/>
                                                    Google Maps
                                                </a>
                                            </div>
                                        ))}
                                        {locaisFiltrados.length === 0 && (
                                            <p>Nenhuma cidade encontrada para &quot;{termoBusca}&quot;.</p>
                                        )}
                                    </div>

                                    {totalPaginas > 1 && (
                                        <ul className="page-numbers">
                                            <li onClick={this.primeiraPagina}>Primeira</li>
                                            <li onClick={this.paginaAnterior}>Anterior</li>
                                            {numerosPagina.map(numero => (
                                                <li
                                                    key={numero}
                                                    className={numero === paginaAtualCorrigida ? 'active' : ''}
                                                    onClick={() => this.irParaPagina(numero)}
                                                >
                                                    {numero}
                                                </li>
                                            ))}
                                            <li onClick={() => this.proximaPagina(totalPaginas)}>Próxima</li>
                                            <li onClick={() => this.ultimaPagina(totalPaginas)}>Última</li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}
